import RecargoCrud from './RecargoCrud'
export { RecargoCrud }
export default RecargoCrud
